/* eslint-disable react/prop-types */
import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={12} viewBox="1095.319 35.5 18 12" {...props}>
    <path
      d="M1109.832 40.03a5.617 5.617 0 0 0-5.513-4.53 5.622 5.622 0 0 0-4.987 3.03 4.496 4.496 0 0 0-4.013 4.47c0 2.482 2.018 4.5 4.5 4.5h9.75c2.07 0 3.75-1.68 3.75-3.75a3.732 3.732 0 0 0-3.487-3.72Zm-.263 5.97h-9.75a3 3 0 1 1 0-6h.533a4.126 4.126 0 0 1 3.967-3 4.123 4.123 0 0 1 4.125 4.125v.375h1.125a2.247 2.247 0 0 1 2.25 2.25 2.247 2.247 0 0 1-2.25 2.25Z"
      fill={props.fill ? props.fill : '#f000'}
      fillRule="evenodd"
      data-name="Icon material-cloud-queue"
    />
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// src/assets/Cloud.jsx